// import { useState } from "react"
// import { Link } from "react-router-dom";
// import { BASE_URL } from '../apiConfig';
// import { Eye, Pin, PinOff, Sparkles } from "lucide-react";
// import DeleteModal from '../cors/DeleteModal'; 
// import { useAuth } from "../context/AuthProvider";
// import { toast } from 'sonner';

// export default function ProductList({ role, product, getStatusColor, fetchProducts, newProducts, pinnedproducts }) {
//   const { token, roles } = useAuth();
//   const [imageError, setImageError] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isPinned, setIsPinned] = useState(
//     (pinnedproducts || []).includes(product.id)
//   );

//   const isNewProduct = (newProducts || []).some(newProd => newProd.id === product.id);

//   const deleteProduct = async () => {
//     setIsModalOpen(false); 

//     try {
//       const res = await fetch(BASE_URL+`/api/products/${product.id}`, {
//         method: "DELETE",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       })

//       if (res.ok) {
//         toast.success("Delete product reussi");
//         fetchProducts();
//       } else {
//         toast.error("Delete product failed");
//       }
//     } catch (error) {
//       toast.error("Delete product failed");
//     }
//   }

//   const togglePin = async () => {
//     try {
//       const res = await fetch(`${BASE_URL}/api/pin-products`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`
//         },
//         body: JSON.stringify({ product_id: product.id })
//       });

//       const data = await res.json();
//       if (res.ok) {
//         if (data.status === "pinned") {
//           toast.success("Produit épinglé");
//           setIsPinned(true);
//         } else {
//           toast.success("Produit désépinglé");
//           setIsPinned(false);
//         }
//         fetchProducts();
//       } else {
//         toast.error("Erreur lors du pin/unpin");
//       }
//     } catch (err) {
//       toast.error("Erreur réseau");
//     }
//   };

//   const formatPrice = (price) => {
//     return new Intl.NumberFormat("fr", {
//       style: "currency",
//       currency: "MAD",
//     }).format(price)
//   }

//   return (
//     <div className="transition-all duration-300 border-b border-gray-100">
//       <div className={`w-full min-w-0 grid ${role !== 0 ? 'grid-cols-11 max-xl:grid-cols-9' : 'grid-cols-9 max-xl:grid-cols-7'} gap-4 items-center py-1 px-6 max-xl:px-3`}>
//         <div className="col-span-4 max-xl:col-span-2 flex items-center gap-4">
//           <div className="relative w-14 h-14 flex-shrink-0 rounded-xl overflow-hidden bg-gradient-to-br from-[var(--color-primary-50)] via-white to-gray-100">
//             {!imageError && product.image_py ? (
//               <img
//                 src={`${BASE_URL}/storage/${product.image_py}`}
//                 alt={product.name}
//                 fill
//                 className="object-cover transition-transform duration-300 group-hover:scale-105"
//                 onError={() => setImageError(true)}
//               />
//             ) : (
//               <div className="flex items-center justify-center h-full">
//                 <svg className="h-6 w-6 text-[var(--color-primary-100)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
//                   />
//                 </svg>
//               </div>
//             )}
//             {(product.status !== "active" || (product.price?.stock || 0) <= 0) && (
//               <div className="absolute top-2 left-[-25px] bg-red-500 text-white text-[5px] font-bold px-6 pb-0.5 rotate-[-45deg] shadow-md">
//                 غير متوفر حاليا
//               </div>
//             )}
//           </div>
          
//           {/* Name and Category */}
//           <div className="min-w-0">
//             <h3 className="font-semibold text-xs max-xl:text-[11px] text-gray-900 truncate">
//               {product.name}
//             </h3>
//             <p className="text-xs max-xl:text-[10px] text-gray-500 truncate">
//               {product.category?.title}
//             </p>
//           </div>
//           {isPinned && (
//             <span className="text-[var(--color-primary-500)]">
//               <Pin size={15} className="rotate-30"/>
//             </span>
//           )}
//         </div>
        
//         {/* Status Column */}
//         <div className="col-span-1 grid space-y-0.5">
//           <span className={`px-1.5 py-0.5 text-nowrap rounded-full text-[10px] max-w-max font-semibold ${getStatusColor(product.status)}`}>
//             {product.status.replace(/_/g, " ").toUpperCase()}
//           </span>
//           {product.product_expired_soon === true && (
//             <span className="bg-blue-100 text-blue-800 px-1.5 py-0.5 max-w-max rounded-full text-[10px] font-semibold">LIMITED</span>
//           )}
//           {isNewProduct && (
//             <span className="flex gap-0.5 items-center bg-green-500 text-white text-[10px] font-semibold px-1.5 py-0.5 rounded-full max-w-max shadow-md">
//               <Sparkles size={12} />
//               Nouveau
//             </span>
//           )}
          
//         </div>
        
//         {/* Rating Column */}
//         <div className="col-span-1">
//           <div className="flex">
//             {[...Array(5)].map((_, i) => (
//               <span key={i} className={i < product.rating ? 'text-yellow-500 text-sm' : 'text-gray-300 text-sm'}>
//                 ★
//               </span>
//             ))}
//           </div>
//         </div>
        

//         {/* Price Column */}
//         {
//           role !== 0 &&
//           <>
//             <div className="col-span-1 text-center text-xs text-gray-600">
//               <div className="text-xs max-xl:text-[11px] font-bold ">{product.price?.stock}</div>
//             </div>
//             <div className="col-span-1">
//               <div className="text-xs max-xl:text-[11px] font-bold text-teal-600">{formatPrice(product.price?.achat_price)}</div>
//             </div>
//           </>
//         }
//         <div className="col-span-1">
//           <div className="text-xs max-xl:text-[11px] font-bold text-teal-600">{formatPrice(product.price?.saller_price)}</div>
//         </div>
//         <div className="col-span-1">
//           <div className="text-xs max-xl:text-[11px] font-bold text-teal-600">{formatPrice(product.price?.selling_price)}</div>
//         </div>
        
//         {/* Actions Column */}
//         <div className="col-span-1 flex justify-center gap-1 max-lg:gap-0.5">
//           <Link to={`/products/${product.id}`}>
//             <button className="p-1.5 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-xl transition-all duration-300">
//               <Eye size={15} />
//             </button>
//           </Link>
          
//           {/* Pin Button */}
//           <button 
//             onClick={togglePin}
//             className="p-1.5 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-xl transition-all duration-300"
//           >
//             {isPinned ? <PinOff size={15} /> : <Pin size={15} />}
//           </button>
          
//           {
//             (role === 1 || (roles.edit_product === 1 && role === 2)) &&
            
//               <Link to={`/products/update/${product.id}`}>
//                 <button className="p-1.5 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-xl transition-all duration-300">
//                   <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                     />
//                   </svg>
//                 </button>
//               </Link>
//           }
//           {
//             (role === 1 || (roles.delete_product === 1 && role === 2)) &&
//               <button
//                 onClick={() => setIsModalOpen(true)} 
//                 className="p-1.5 cursor-pointer border-2 border-gray-200 hover:border-red-400 text-gray-600 hover:text-red-400 rounded-xl transition-all duration-300"
//               >
//                 <svg className="h-3.5 w-3.5 " fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
//                   />
//                 </svg>
//               </button>
//           }
//         </div>
//       </div>
//       {
//         isModalOpen &&
//           <DeleteModal
//             isOpen={isModalOpen}
//             onClose={() => setIsModalOpen(false)}
//             onConfirm={deleteProduct}
//             title="Delete Product"
//             message="Are you sure you want to delete the Product?"
//             itemName={product.name}
//           />
//       }
//     </div>
//   )
// }

import { useState } from "react"
import { Link } from "react-router-dom";
import { BASE_URL } from '../apiConfig';
import { Eye, Pin, PinOff, Sparkles } from "lucide-react";
import DeleteModal from '../cors/DeleteModal'; 
import { useAuth } from "../context/AuthProvider";
import { toast } from 'sonner';
import { useLanguage } from "../context/LanguageProvider";

export default function ProductList({ role, product, getStatusColor, fetchProducts, newProducts, pinnedproducts }) {
  const { token, roles } = useAuth();
  const { t } = useLanguage();
  const [imageError, setImageError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPinned, setIsPinned] = useState(
    (pinnedproducts || []).includes(product.id)
  );

  const isNewProduct = (newProducts || []).some(newProd => newProd.id === product.id);

  const deleteProduct = async () => {
    setIsModalOpen(false); 

    try {
      const res = await fetch(BASE_URL+`/api/products/${product.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })

      if (res.ok) {
        toast.success(t('products.delete_success'));
        fetchProducts();
      } else {
        toast.error(t('products.delete_failed'));
      }
    } catch (error) {
      toast.error(t('products.delete_failed'));
    }
  }

  const togglePin = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/pin-products`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ product_id: product.id })
      });

      const data = await res.json();
      if (res.ok) {
        if (data.status === "pinned") {
          toast.success(t('products.pinned_success'));
          setIsPinned(true);
        } else {
          toast.success(t('products.unpinned_success'));
          setIsPinned(false);
        }
        fetchProducts();
      } else {
        toast.error(t('products.pin_error'));
      }
    } catch (err) {
      toast.error(t('messages.network_error'));
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("fr", {
      style: "currency",
      currency: "MAD",
    }).format(price)
  }

  return (
    <div className="transition-all duration-300 border-b border-gray-100">
      <div className={`w-full grid ${role !== 0 ? 'grid-cols-11' : 'grid-cols-9'} gap-2 sm:gap-3 lg:gap-4 items-center py-2 px-3 sm:px-4 lg:px-6`}>
        {/* Product Column with Image and Name */}
        <div className="col-span-4 md:col-span-3 flex items-center gap-2 sm:gap-3 min-w-0">
          <div className="relative w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex-shrink-0 rounded-lg sm:rounded-xl overflow-hidden bg-gradient-to-br from-[var(--color-primary-50)] via-white to-gray-100">
            {!imageError && product.image_py ? (
              <img
                src={`${BASE_URL}/storage/${product.image_py}`}
                alt={product.name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                onError={() => setImageError(true)}
              />
            ) : (
              <div className="flex items-center justify-center h-full">
                <svg className="h-5 w-5 sm:h-6 sm:w-6 text-[var(--color-primary-100)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  />
                </svg>
              </div>
            )}
            {(product.status !== "active" || (product.price?.stock || 0) <= 0) && (
              <div className="absolute top-1 sm:top-2 left-[-20px] sm:left-[-25px] bg-red-500 text-white text-[4px] sm:text-[5px] font-bold px-4 sm:px-6 pb-0.5 rotate-[-45deg] shadow-md">
                {t('products.unavailable_now')}
              </div>
            )}
          </div>
          
          {/* Name and Category */}
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-1">
              <h3 className="font-semibold text-[10px] sm:text-xs text-gray-900 truncate">
                {product.name}
              </h3>
              {isPinned && (
                <span className="text-[var(--color-primary-500)] flex-shrink-0">
                  <Pin size={12} className="sm:hidden"/>
                  <Pin size={15} className="hidden sm:block"/>
                </span>
              )}
            </div>
            <p className="text-[9px] sm:text-xs text-gray-500 truncate">
              {product.category?.title}
            </p>
          </div>
        </div>
        
        {/* Status Column */}
        <div className="col-span-1 flex flex-col gap-0.5">
          <span className={`px-1 sm:px-1.5 py-0.5 text-nowrap rounded-full text-[8px] sm:text-[10px] max-w-max font-semibold ${getStatusColor(product.status)}`}>
            {product.status.replace(/_/g, " ").toUpperCase()}
          </span>
          {product.product_expired_soon === true && (
            <span className="bg-blue-100 text-blue-800 px-1 sm:px-1.5 py-0.5 max-w-max rounded-full text-[8px] sm:text-[10px] font-semibold">{t('products.limited')}</span>
          )}
          {isNewProduct && (
            <span className="flex gap-0.5 items-center bg-green-500 text-white text-[8px] sm:text-[10px] font-semibold px-1 sm:px-1.5 py-0.5 rounded-full max-w-max shadow-md">
              <Sparkles size={10} className="sm:hidden"/>
              <Sparkles size={12} className="hidden sm:block"/>
              <span className="hidden sm:inline">{t('products.new')}</span>
              <span className="sm:hidden">{t('products.new_short')}</span>
            </span>
          )}
        </div>
        
        {/* Rating Column */}
        <div className="col-span-1">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <span key={i} className={`${i < product.rating ? 'text-yellow-500' : 'text-gray-300'} text-xs sm:text-sm`}>
                ★
              </span>
            ))}
          </div>
        </div>
        
        {/* Stock and Purchase Price (Admin/Manager only) */}
        {role !== 0 && (
          <>
            <div className="col-span-1 text-center">
              <div className="text-[10px] sm:text-xs font-bold text-gray-900">{product.price?.stock}</div>
            </div>
            <div className="col-span-1">
              <div className="text-[10px] sm:text-xs font-bold text-teal-600 truncate">{formatPrice(product.price?.achat_price)}</div>
            </div>
          </>
        )}
        
        {/* Price Columns */}
        <div className="col-span-1">
          <div className="text-[10px] sm:text-xs font-bold text-teal-600 truncate">{formatPrice(product.price?.saller_price)}</div>
        </div>
        <div className="col-span-1">
          <div className="text-[10px] sm:text-xs font-bold text-teal-600 truncate">{formatPrice(product.price?.selling_price)}</div>
        </div>
        
        {/* Actions Column */}
        <div className="col-span-1 md:pl-10 flex justify-center gap-1">
          <Link to={`/products/${product.id}`}>
            <button className="p-1 sm:p-1.5 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-lg sm:rounded-xl transition-all duration-300">
              <Eye size={13} className="sm:hidden"/>
              <Eye size={15} className="hidden sm:block"/>
            </button>
          </Link>
          
          {/* Pin Button */}
          <button 
            onClick={togglePin}
            className="p-1 sm:p-1.5 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-lg sm:rounded-xl transition-all duration-300"
          >
            {isPinned ? (
              <>
                <PinOff size={13} className="sm:hidden"/>
                <PinOff size={15} className="hidden sm:block"/>
              </>
            ) : (
              <>
                <Pin size={13} className="sm:hidden"/>
                <Pin size={15} className="hidden sm:block"/>
              </>
            )}
          </button>
          
          {/* Edit Button */}
          {(role === 1 || (roles?.edit_product === 1 && role === 2)) && (
            <Link to={`/products/update/${product.id}`}>
              <button className="p-1 sm:p-1.5 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-lg sm:rounded-xl transition-all duration-300">
                <svg className="h-3 w-3 sm:h-3.5 sm:w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
            </Link>
          )}
          
          {/* Delete Button */}
          {(role === 1 || (roles?.delete_product === 1 && role === 2)) && (
            <button
              onClick={() => setIsModalOpen(true)} 
              className="p-1 sm:p-1.5 cursor-pointer border-2 border-gray-200 hover:border-red-400 text-gray-600 hover:text-red-400 rounded-lg sm:rounded-xl transition-all duration-300"
            >
              <svg className="h-3 w-3 sm:h-3.5 sm:w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
      
      {isModalOpen && (
        <DeleteModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={deleteProduct}
          title={t('products.delete_title')}
          message={t('products.delete_message')}
          itemName={product.name}
        />
      )}
    </div>
  )
}
